import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

// Assets
import constructionBothead from '../../assets/img/construction-bothead.svg'
// Styles
import styles from './UnderConstructionModal.module.scss'

// Components
import { If, Text, Button, CloseButton } from './..'

const UnderConstructionModal = ({
  className,
  handleModalToggle,
  underConstructionActive,
}) => {
  return (
    <If condition={underConstructionActive}>
      <div className={classnames(styles.root, className)}>
        <div className={styles.wrapper} onClick={handleModalToggle}>
          <div className={styles.content} style={{ top: '120px' }}>
            <div className={styles.closeRow}>
              <CloseButton
                className={styles.closeButton}
                onClick={handleModalToggle}
              />
            </div>
            <div className={styles.contentContainer}>
              <div className={styles.imageRow}>
                <img src={constructionBothead} alt='under construction' />
              </div>
              <div className={styles.textAndButtonWrapper}>
                <div className={styles.textRow}>
                  <Text align='center' className={styles.text}>
                    This feature is still in the works
                  </Text>
                </div>
                <div className={styles.subTextRow}>
                  <Text className={styles.subText}>
                    We hope to add this capability sooner rather than later.
                  </Text>
                </div>
                <div className={styles.buttonRow}>
                  <Button
                    className={styles.button}
                    onClick={handleModalToggle}
                    fullWidth
                    regular
                    children={'Close'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </If>
  )
}

UnderConstructionModal.propTypes = {
  className: PropTypes.string,
  underConstructionActive: PropTypes.bool,
  handleModalToggle: PropTypes.func.isRequired,
}

export default UnderConstructionModal
